import React, { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import PromptAnalyzer from "./components/PromptAnalyzer";
import Login from "./components/Login";

function AppContent() {
	const { user, loading, logout } = useAuth();
	const [showLogin, setShowLogin] = useState(false);

	if (loading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="text-xl">Loading...</div>
			</div>
		);
	}

	// Show login modal if requested
	if (showLogin && !user) {
		return <Login onClose={() => setShowLogin(false)} />;
	}

	return (
		<div className="min-h-screen bg-gray-50">
			<header className="bg-white shadow-sm">
				<div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
					<h1 className="text-xl font-bold text-gray-900">
						Analyseur de Prompts
					</h1>
					<div className="flex items-center gap-4">
						{user ? (
							<>
								<span className="text-sm text-gray-600">
									✓ Connecté (100 req/h)
								</span>
								<button
									onClick={logout}
									className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
								>
									Déconnexion
								</button>
							</>
						) : (
							<>
								<span className="text-sm text-gray-600">
									Mode anonyme (10 req/h)
								</span>
								<button
									onClick={() => setShowLogin(true)}
									className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
								>
									Se connecter
								</button>
							</>
						)}
					</div>
				</div>
			</header>
			<main>
				<div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
					<PromptAnalyzer />
				</div>
			</main>
			<footer className="bg-white mt-auto">
				<div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 text-center text-gray-500 text-sm">
					Construit avec FastAPI, React et l'API Anthropic
				</div>
			</footer>
		</div>
	);
}

function App() {
	return (
		<AuthProvider>
			<AppContent />
		</AuthProvider>
	);
}

export default App;
